(function (Drupal) {
    Drupal.behaviors.rs_template_stock_ticker = {
        attach: function (context, settings) {
            var neoExchangeWidgetSymbol =   document.querySelectorAll('.neoexchange-widget-symbol')[0].textContent;
            var neoExchangeWidgetUrl = "https://www.neo.inc/rest-api/service/watchlist/" + neoExchangeWidgetSymbol;

            function neoExchangeWidgetRequestHandler() {
                var responseJson = JSON.parse(this.responseText);
                var first = responseJson.payload[0];
                if(responseJson.payload[0]){
                    document.querySelectorAll('.neoexchange-widget-securityName')[0].textContent   = first.securityName;
                    document.querySelectorAll('.rs-stock-ticker--name')[0].classList.remove('hidden');
                    document.querySelectorAll('.neoexchange-widget-salePrice')[0].textContent      = first.salePrice;
                    document.querySelectorAll('.rs-stock-ticker--sale-price')[0].classList.remove('hidden');
                    document.querySelectorAll('.neoexchange-widget-closePrice')[0].textContent     = first.closePrice;
                    document.querySelectorAll('.rs-stock-ticker--close-price')[0].classList.remove('hidden');
                    document.querySelectorAll('.neoexchange-widget-lastUpdateDate')[0].textContent = first.lastUpdateDate;
                    document.querySelectorAll('.neoexchange-widget-lastUpdateTime')[0].textContent = first.lastUpdateTime;
                    document.querySelectorAll('.rs-stock-ticker--datetime')[0].classList.remove('hidden');
                } else {
                    console.log("error: no data returned");
                }
            }

            function neoExchangeWidgetAbortHandler() { console.log("abort: " + this.responseText); }
            function neoExchangeWidgetErrorHandler() { console.log("error: " + this.responseText); }

            function neoExchangeUpdateWidget() {
                var req = new XMLHttpRequest();
                req.addEventListener("load",neoExchangeWidgetRequestHandler);
                req.addEventListener("abort",neoExchangeWidgetAbortHandler);
                req.addEventListener("error",neoExchangeWidgetErrorHandler);
                req.open("GET",neoExchangeWidgetUrl);
                req.send();
            }
            window.onload = function() {
                setTimeout(neoExchangeUpdateWidget,0);
                setInterval(neoExchangeUpdateWidget,30000);
            };
        }
    };
})(Drupal);








